import Vue from "vue";
import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";

/**
 * Redworks Base component 전역 로딩
 */

const requireComponent = require.context("@/redworks/components/base", true, /\.vue$/);

requireComponent.keys().forEach((fileName) => {
  const componentConfig = requireComponent(fileName);

  const componentName = upperFirst(
    camelCase(fileName.replace(/^\.\//, "").replace(/\.\w+$/, ""))
  );

  Vue.component(
    `${componentName}`,
    componentConfig.default || componentConfig
  );
});
